<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.user_id" class="modal-card-title">Crear Usuario</p>
          <p v-else class="modal-card-title">Editar Usuario</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="user.name"
              v-model="user.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Paterno">
            <b-input
              type="text"
              :value="user.pather_lastname"
              v-model="user.pather_lastname"
              placeholder="Apellido Paterno"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Materno">
            <b-input
              type="text"
              :value="user.mother_lastname"
              v-model="user.mother_lastname"
              placeholder="Apellido Materno"
              required
            ></b-input>
          </b-field>
          <b-field label="Rut">
            <b-input type="text" :value="user.rut" v-model="user.rut" placeholder="RUT" required></b-input>
          </b-field>
          <b-field label="Email">
            <b-input
              type="email"
              :value="user.email"
              v-model="user.email"
              placeholder="Your email"
              required
            ></b-input>
          </b-field>
          <b-field label="Password" v-if="!this.user_id">
            <b-input
              type="password"
              :value="user.password"
              v-model="user.password"
              password-reveal
              placeholder="Password"
              required
            ></b-input>
          </b-field>
          <b-field label="Establecimiento">
            <b-select placeholder="Seleccionar Establecimiento" v-model="user.stablishment_id" expanded>
              <option
                v-for="stablishment in listStablishment"
                :value="stablishment.id"
                :key="stablishment.id"
              >{{ stablishment.name }}</option>
            </b-select>
          </b-field>    
           <b-field label="Locación">
            <b-select placeholder="Seleccionar Locación" v-model="user.location_id" expanded>
              <option
                v-for="locations in listLocation"
                :value="locations.id"
                :key="locations.id"
              >{{ locations.name }}</option>
            </b-select>
          </b-field>    
            <b-field label="Estamento">
            <b-select placeholder="Seleccionar Estamento" v-model="user.stament_id" expanded>
              <option v-for="stament in listStament" :value="stament.id" :key="stament.id">{{ stament.name }}</option>
            </b-select>
          </b-field>
     
             <b-field label="Calidad Contractual">
            <b-select placeholder="Seleccionar Calidad Contractual" v-model="user.type_user_id" expanded>
              <option v-for="user_type in listUserType" :value="user_type.id" :key="user_type.id">{{ user_type.name }}</option>
            </b-select>
          </b-field>            
          <b-field label="Perfil">
            <b-select placeholder="Seleccionar Perfil" v-model="user.role_id" expanded>
              <option v-for="rol in listRoles" :value="rol.id" :key="rol.id">{{ rol.type }}</option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.user_id" class="button is-primary" @click="createUser()">Guardar</button>
          <button v-else class="button is-primary" @click="editUser()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["isComponentModalActive", "closeBasic", "chargeListUser", "user_id"],
  data() {
    return {
      user: {
        name: "",
        pather_lastname: "",
        mother_lastname: "",
        rut: "",
        email: "",
        password: "",
        stablishment_id: "",
        role_id: "",
        stament_id:"",
        type_user_id:"",
        location_id:""
      },
    listStablishment: [],
      listRoles: [],
      listStament:[],
      listUserType:[],
      listLocation:[],
      isLoading:false
    };
  },
  created: function() {
    this.isLoading=true;
    this.chargeLists().then(() => {
      if (this.user_id) {
        this.chargeUserData().then(()=>{
          this.isLoading=false;
        });
      }else{
        this.isLoading=false;
      }
    });
  },
  methods: {
    createUser: async function() {
      this.isLoading=true;
      let data = {
        ...this.user
      };
      await this.$http.post(`api/${localStorage.getItem('perfil')}/user`, data).then(
        response => {
          //Limpia el objeto User
          for (const i in this.user) {
            this.user[i] = "";
          }
          console.log("POST:", response.body);
          this.chargeListUser();
          this.closeBasic();
          this.toast("Creado el usuario", "is-success");
          this.isLoading=false;
        },
        response => {
          this.toast("error al crear", "is-danger");
          this.isLoading=false;
          console.log("error: ", response);
        }
      );
    },
    editUser: function() {
      this.isLoading=true;
      let data = {
        ...this.user
      };
      this.$http.put(`api/${localStorage.getItem('perfil')}/user/` + this.user_id, data).then(
        response => {
          //Limpia el objeto User
          for (const i in this.user) {
            this.user[i] = "";
          }
          console.log("PUT:", response.body);
          this.chargeListUser();
          this.closeBasic();
          this.toast("Editado el Usuario", "is-success");
          this.isLoading=false;
        },
        response => {
          this.toast("error al editar", "is-danger");
          this.isLoading=false;
          console.log("error: ", response);
        }
      );
    },
    chargeLists: async function() {
      await this.$http.get(`api/${localStorage.getItem('perfil')}/stablishment`).then(
        response => {
          this.listStablishment = response.body.data;
          console.log(this.listStablishment);
        },
        response => {
          console.log("error: ", response);
        }
      );
        await this.$http.get(`api/${localStorage.getItem('perfil')}/stament`).then(
        response => {
          this.listStament = response.body.data;
          console.log(this.listStament);
        },
        response => {
          console.log("error: ", response);
        }
      );
        await this.$http.get(`api/${localStorage.getItem('perfil')}/location`).then(
        response => {
          this.listLocation = response.body.data;
          console.log(this.listLocation);
        },
        response => {
          console.log("error: ", response);
        }
      );
         await this.$http.get(`api/${localStorage.getItem('perfil')}/type_user`).then(
        response => {
          this.listUserType = response.body.data;
          console.log(this.listUserType);
        },
        response => {
          console.log("error: ", response);
        }
      );
      await this.$http.get(`api/${localStorage.getItem('perfil')}/role`).then(
        response => {
          this.listRoles = response.body.role;
          console.log(this.listRoles);
        },
        response => {
          console.log("error: ", response);
        }
      );
    },
    chargeUserData: async function() {
      await this.$http.get(`api/${localStorage.getItem('perfil')}/user/` + this.user_id).then(
        response => {
          (this.user.name = response.body.user.name),
            (this.user.pather_lastname = response.body.user.pather_lastname),
            (this.user.mother_lastname = response.body.user.mother_lastname),
            (this.user.rut = response.body.user.rut),
            (this.user.email = response.body.user.email),
            (this.user.password = response.body.user.password),
            (this.user.stablishment_id = response.body.user.stablishment_id),
            (this.user.stament_id = response.body.user.stament_id),
            (this.user.type_user_id = response.body.user.type_user_id),
            (this.user.location_id = response.body.user.location_id),

            (this.user.role_id = response.body.user.role_id);
        },
        response => {
          console.log(response);
        }
      );
    }
  }
};
</script>